import { APICore } from 'src/helpers/api/apiCore';
import config from 'src/config';
const apiBaseUrl = config.API_URL;
const api = new APICore();

// add panel Rate Card
function creatPanelRateCard(params: any) {
    const baseUrl = `/rateCard/createPanelRate`;
    return api.create(`${baseUrl}`, params);
}
// update panel Rate Card
function updatePanelRateCard(params: any) {
    const baseUrl = '/rateCard/updPanelRate';
    return api.update(`${baseUrl}`, params);
}

// get all panel Rate Cards
function getAllPanelRateCards(params: any) {
    const baseUrl = '/rateCard/getAllPanelRate';
    return api.create(`${baseUrl}`, params);
}

// get test Rate Card
function getPanelRateCard(params: any) {
    const baseUrl = '/rateCard/getPanelRateDtl';
    return api.create(`${baseUrl}`, params);
}

export { creatPanelRateCard, updatePanelRateCard, getAllPanelRateCards, getPanelRateCard };
